import type { TFinancingOfferMapper } from '@/components/composed/financing/types'
import { messages } from './messages'

export const addCommentForConsultingForm: TFinancingOfferMapper = body => {
  return {
    ...body,
    comment: messages.comment,
  }
}
